// extracted by mini-css-extract-plugin
export default {"iconContainer":"Popover_iconContainer__Qmg2+"};